// source: template-project@7007a338a apps/backoffice/src/pages/onboarding-new/BrandLocationCard.tsx (normalizeDomain, readWebsiteReply) + apps/backoffice/src/pages/onboarding-v2/SiteComposer.tsx (DOMAIN)
/**
 * Reads what was typed for "What's your brand's website?". A social or marketplace link is not the store
 * (P8): the chat answers it with a prototype reply and asks again. The BFF checks the same thing server-side
 * (`not_a_store`), so this only saves a round trip and is never the only guard.
 */
import { MAX_URL_LENGTH } from '@/contracts/onboarding-session';

import { detectPresence, type Presence } from './presence';

const DOMAIN = /^(?!-)[a-z0-9-]+(\.[a-z0-9-]+)*\.[a-z]{2,}$/i;

export const normalizeDomain = (value: string): string =>
  value.trim().replace(/^https?:\/\//i, '').replace(/^www\./i, '').replace(/\/.*$/, '');

/** True when `text` reads as a domain once the scheme, `www.` and path are dropped: what enables the composer's send. */
export const isDomain = (text: string): boolean => DOMAIN.test(normalizeDomain(text));

export type WebsiteReply =
  | { kind: 'domain'; domain: string }
  | { kind: 'presence'; presence: Presence }
  | { kind: 'invalid' };

export function readWebsiteReply(text: string): WebsiteReply {
  // The BFF refuses anything past this; a pasted `?domain=` is not held to the field's maxLength.
  if (text.length > MAX_URL_LENGTH) return { kind: 'invalid' };
  const bare = normalizeDomain(text);
  if (!DOMAIN.test(bare)) return { kind: 'invalid' };
  const presence = detectPresence(text);
  return presence ? { kind: 'presence', presence } : { kind: 'domain', domain: bare };
}
